
const setNewAnglesForEachUser = (selectedUserIndex: number, userAngles: any): any => {

	let numberOfPlayers: number = Object.keys(userAngles).length;
	let newUserAngles: any = {};
	let indexOfAvatarOnThe270Position: number = 0;

	for (let index in userAngles) {
		if (userAngles[index] === 270) {
			indexOfAvatarOnThe270Position = parseInt(index);
		}
	}

	const updateTheIndexBasedOnTheOldOne = (oldIndex: number) => {
		let updatedIndex = 0;
		let gap = indexOfAvatarOnThe270Position - selectedUserIndex;


		if (indexOfAvatarOnThe270Position < selectedUserIndex) {
			gap = numberOfPlayers - Math.abs(selectedUserIndex - indexOfAvatarOnThe270Position);
		}

		updatedIndex = oldIndex + gap;

		if (updatedIndex >= numberOfPlayers) {
			updatedIndex = updatedIndex - numberOfPlayers;
		}

		return updatedIndex
	}

	for (let index in userAngles) {
		let updatedIndex = updateTheIndexBasedOnTheOldOne(parseInt(index));
		newUserAngles[index] = userAngles[String(updatedIndex)];
	}

	return newUserAngles;

};

export default setNewAnglesForEachUser;
